var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.73 20.279 14.3 1.42a2.57 2.57 0 0 0-4.6 0L.27 20.28A2.571 2.571 0 0 0 2.571 24H21.43a2.57 2.57 0 0 0 2.3-3.721Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.73 20.279 14.3 1.42a2.57 2.57 0 0 0-4.6 0L.27 20.28A2.571 2.571 0 0 0 2.571 24H21.43a2.57 2.57 0 0 0 2.3-3.721ZM10.713 8.572a1.286 1.286 0 1 1 2.572 0v5.143a1.286 1.286 0 0 1-2.572 0V8.572Zm1.286 12a1.714 1.714 0 1 1 0-3.428 1.714 1.714 0 0 1 0 3.428Z",
    fill: "#F26526"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgWarning;